/* globals twttr, instgrm, refreshFsLightbox */
import { fetchPosters, renderDetailView } from '../es6/2021-poster-challenge';
import { GalleryModal } from '../es6/creative-challenge/gallery';
import config from '../es6/config';

const { staticFile } = config;
// Twitter loader
window.twttr = (function (d, s, id) {
  const fjs = d.getElementsByTagName(s)[0];
  const t = window.twttr || {};
  if (d.getElementById(id)) return t;
  const js = d.createElement(s);
  js.id = id;
  js.src = 'https://platform.twitter.com/widgets.js';
  fjs.parentNode.insertBefore(js, fjs);

  // eslint-disable-next-line no-underscore-dangle
  t._e = [];
  t.ready = function (f) {
    // eslint-disable-next-line no-underscore-dangle
    t._e.push(f);
  };

  return t;
}(document, 'script', 'twitter-wjs'));

// eslint-disable-next-line no-underscore-dangle
window.__igEmbedLoaded = function () {
  $('.liveblog-entry-instagram:not(.processed)').addClass(['processed', 'loaded']);
};

// Posters
const BASE_PATH = staticFile('features/2021-posters-celebration');
const posterLoader = fetchPosters(
  `${BASE_PATH}/2021-poster-celebration.json`,
  `${BASE_PATH}/files`,
  `${BASE_PATH}/files-thumb`
);
const posterModal = new GalleryModal();

export default function refresh() {
  twttr.ready(() => {
    $('.liveblog-entry-twitter:not(.processed)').each((i, element) => {
      twttr.widgets.load(element).then(() => {
        $(element).addClass('loaded');
      });
      $(element).addClass('processed');
    });
  });

  if ($('.liveblog-entry-instagram:not(.processed)').length > 0 && instgrm !== undefined) {
    instgrm.Embeds.process();
  }

  let refreshLightboxes = false;
  $('.liveblog-entry-2023-comic:not(.processed)').each((i, element) => {
    const comicID = $(element).attr('data-id');
    $('<a class="liveblog-entry-2022-photo-thumbnail"></a>')
      .attr('data-fslightbox', comicID)
      .attr('href', staticFile(`features/2023-comic-challenge/files/xl/${comicID}.jpg`))
      .append(
        $('<img class="img-fluid border-polaroid mb-2">')
          .attr('alt', '')
          .attr('src', staticFile(`features/2023-comic-challenge/files/md/${comicID}.jpg`))
      )
      .appendTo(element);
    $(element).addClass(['processed', 'loaded']);
    refreshLightboxes = true;
  });
  $('.liveblog-entry-2022-photo:not(.processed)').each((i, element) => {
    const photoID = $(element).attr('data-id');
    $('<a class="liveblog-entry-2022-photo-thumbnail"></a>')
      .attr('data-fslightbox', photoID)
      .attr('href', staticFile(`features/2022-photo-challenge/files/lg/${photoID}.jpg`))
      .append(
        $('<img class="img-fluid border-polaroid mb-2">')
          .attr('alt', '')
          .attr('src', staticFile(`features/2022-photo-challenge/files/md/${photoID}.jpg`))
      )
      .appendTo(element);
    $(element).addClass(['processed', 'loaded']);
    refreshLightboxes = true;
  });
  if (refreshLightboxes) {
    refreshFsLightbox();
  }

  $('.liveblog-entry-poster:not(.processed)').each((i, element) => {
    posterLoader.then((posters) => {
      const posterID = $(element).attr('data-poster-id');
      const poster = posters.find((item) => item.id === posterID);
      if (poster) {
        $('<a class="liveblog-entry-poster-thumbnail"></a>')
          .attr('href', '#')
          .append(
            $('<img class="img-fluid">')
              .attr('alt', '')
              .attr('src', poster.image)
          )
          .on('click', (ev) => {
            ev.preventDefault();
            // Navigate via location.replace to create a better history
            // when navigating back after opening several items
            posterModal.setContent(renderDetailView(poster));
            posterModal.show();
            return false;
          })
          .appendTo(element);
      } else {
        console.error(`Poster with id ${posterID} not found`);
      }
      $(element).addClass(['processed', 'loaded']);
    });
  });
}
